import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Allow Authorization header fallback (token also returned by login)
let bearerToken = null;
try {
  bearerToken = window.localStorage.getItem("omd_token");
} catch (_) {}
if (bearerToken) {
  api.defaults.headers.common["Authorization"] = `Bearer ${bearerToken}`;
}

export const setBearer = (token) => {
  bearerToken = token;
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    try {
      window.localStorage.setItem("omd_token", token);
    } catch (_) {}
  } else {
    delete api.defaults.headers.common["Authorization"];
    try {
      window.localStorage.removeItem("omd_token");
    } catch (_) {}
  }
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
